import React, { useState } from 'react';
import { Input, Button, Modal, Spin, Checkbox, Select } from 'antd';
import { useEmpShortcodeForm, SHORTCODE_LABELS } from './hooks/useEmpShortcodeForm';

const { Option } = Select;

const P111KForm: React.FC = () => {
  const {
    mode, isEditing, loading,
    records, current, currentIdx,
    code, setCode,
    empId, setEmpId,
    isLeader, setIsLeader,
    isOldCode, setIsOldCode,
    bizType, setBizType,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save,
    doDelete, quickSearch,
  } = useEmpShortcodeForm();

  const [searchText, setSearchText] = useState('');

  const handleDelete = () => {
    if (!current) return;
    Modal.confirm({
      title: '確認刪除',
      content: `確定要刪除 簡碼「${current.f11k_01}」員工「${current.f11k_11}」？`,
      okText: '刪除',
      okType: 'danger',
      cancelText: '取消',
      onOk: doDelete,
    });
  };

  const handleQuickSearch = () => {
    if (searchText.trim()) {
      quickSearch(searchText.trim());
    }
  };

  const modeLabel = mode === 'add' ? '新增' : mode === 'edit' ? '修改' : '瀏覽';

  return (
    <Spin spinning={loading}>
      <div className="max-w-2xl mx-auto p-6">
        {/* Title */}
        <h2 className="text-xl font-bold mb-4">
          員工簡碼設定 (pw111kf1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            [{modeLabel}] {records.length > 0 ? `${currentIdx + 1} / ${records.length}` : '無資料'}
          </span>
        </h2>

        {/* Quick Search Bar */}
        <div className="flex items-center gap-2 mb-4">
          <Input
            placeholder="輸入簡碼或員工代號快速查詢"
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            onPressEnter={handleQuickSearch}
            disabled={isEditing}
            style={{ width: 300 }}
            maxLength={8}
          />
          <Button onClick={handleQuickSearch} disabled={isEditing}>查詢</Button>
        </div>

        {/* Navigation Bar */}
        <div className="flex items-center gap-1 mb-4">
          <Button size="small" onClick={navFirst} disabled={isEditing || records.length === 0}>|&lt;</Button>
          <Button size="small" onClick={navPrev} disabled={isEditing || currentIdx <= 0}>&lt;</Button>
          <Button size="small" onClick={navNext} disabled={isEditing || currentIdx >= records.length - 1}>&gt;</Button>
          <Button size="small" onClick={navLast} disabled={isEditing || records.length === 0}>&gt;|</Button>
        </div>

        {/* Form Fields */}
        <div className="space-y-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">員工簡碼 (F11K_01)</label>
            <Select
              value={code}
              onChange={(val: string) => setCode(val)}
              disabled={!isEditing || mode === 'edit'}
              style={{ width: 300 }}
              placeholder="選擇簡碼"
            >
              {Object.entries(SHORTCODE_LABELS).map(([val, label]) => (
                <Option key={val} value={val}>{val} - {label}</Option>
              ))}
            </Select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">員工代號 (F11K_11)</label>
            <Input
              value={empId}
              onChange={e => setEmpId(e.target.value)}
              maxLength={8}
              disabled={!isEditing || mode === 'edit'}
              style={{ width: 300 }}
              placeholder="最多8碼"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">業別類型 (F11K_14)</label>
            <Select
              value={bizType}
              onChange={(val: string) => setBizType(val)}
              disabled={!isEditing}
              style={{ width: 300 }}
              placeholder="選擇業別"
            >
              {Object.entries(SHORTCODE_LABELS).map(([val, label]) => (
                <Option key={val} value={val}>{val} - {label}</Option>
              ))}
            </Select>
          </div>

          <div className="flex items-center gap-6">
            <Checkbox
              checked={isLeader}
              onChange={e => setIsLeader(e.target.checked)}
              disabled={!isEditing}
            >
              組長 (F11K_12)
            </Checkbox>

            <Checkbox
              checked={isOldCode}
              onChange={e => setIsOldCode(e.target.checked)}
              disabled={!isEditing}
            >
              舊代號 (F11K_13)
            </Checkbox>
          </div>
        </div>

        {/* Audit Fields (read-only) */}
        {current && mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-6 space-y-1">
            <div>建立人員: {current.f11k_91} | 建立日期: {current.f11k_92 || '-'}</div>
            <div>修改人員: {current.f11k_93}</div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex items-center gap-2">
          {!isEditing ? (
            <>
              <Button type="primary" onClick={startAdd}>新增</Button>
              <Button onClick={startEdit} disabled={!current}>修改</Button>
              <Button danger onClick={handleDelete} disabled={!current}>刪除</Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={save}>儲存</Button>
              <Button onClick={cancel}>取消</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P111KForm;
